module.exports = __webpack_public_path__ + "img/file-------------------------------------------------------------@1x.300e396b.png";